import { Booth } from '../../../../../../../interfaces/interfaces';
import { BoothFilterSelect } from '../../../../../../account/Booth/BoothFilterSelect';
import { TabContentWrapper } from './TabContentWrapper';

const BoothFiltersTab = ({ booth }: { booth: Booth }) => {
  return (
    <TabContentWrapper>
      <BoothFilterSelect booths={[booth._id]} />
    </TabContentWrapper>
  );
};
export default BoothFiltersTab;
